import React from "react";

import { ContentWrapper } from "./Content.styles";

interface ContentProps {
  testId?: string;
  children: React.ReactNode;
}

/**
 * Content wrapper that contains the left sidebar and main content.
 * Applies margins to account for fixed header and left panel.
 */
const Content: React.FC<ContentProps> = ({ testId, children }) => {
  return <ContentWrapper data-testid={testId}>{children}</ContentWrapper>;
};

export default Content;
